import {Component} from '@angular/core';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  name: string = "Название компании";
  category: string = "Категория";
  images: any = {
    logo: 'logo',
    bg: 'bg'
  };
  points_avail: number = 130;
  address: string = "";
  description: string = "Описание вашей компании будет располагаться на этом месте";
  vk: string = '';
  fb: string = '';
  instagram: string = '';

  constructor() {
  }

  getQueryParams(qs): any {
    qs = qs.split('+').join(' ');

    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = tokens[2];
    }

    return params;
  }

  ionViewDidLoad() {
    let url = new URL(document.URL);
    let params = this.getQueryParams(document.location.search);
    let name = url.searchParams.get("name");
    if (name) {
      this.name = name;
    }
    let category = url.searchParams.get("category");
    if (category) {
      this.category = category;
    }
    let address = url.searchParams.get("address");
    if (address) {
      this.address = address;
    }
    let description = url.searchParams.get("description");
    if (description) {
      this.description = description;
    }
    let vk = url.searchParams.get("vk");
    if (vk) {
      this.vk = vk;
    }
    let fb = url.searchParams.get("fb");
    if (fb) {
      this.fb = fb;
    }
    let instagram = url.searchParams.get("instagram");
    if (instagram) {
      this.instagram = instagram;
    }
    this.images.logo = params.logo + '?alt=media';
    this.images.bg = params.bg + '?alt=media';
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts